import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service'; // ✅ reuse your generic ApiService

@Injectable({
  providedIn: 'root'
})
export class MainContentService {
  private api = inject(ApiService);

  getProjects(): Observable<any[]> {
    return this.api.get<any[]>('/projects');
  }
}
